import { render } from "./LeftSide.vue?vue&type=template&id=36ee1483"
import script from "./LeftSide.vue?vue&type=script&lang=js"
export * from "./LeftSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__